import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

import imgAlexis from '../images/Alexis.JPG';
import imgEmilie from '../images/Emilie.JPG';

export const Praticiens = () => {

    const webSiteEmilie = () => {
        window.open(Helper.urlReservationEmilie)
    }

    const webSiteAlexis = () => {
        window.open(Helper.urlReservationAlexis)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="text-center mb-12">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl mb-4">
                        Qui sommes-nous ?
                    </h1>
                    <div className='flex justify-center'>
                        <div className='w-24 border-b-4' style={{ borderColor: Helper.footerBackGroundColor }}></div>
                    </div>
                    <p className="text-gray-600 text-base sm:text-lg lg:text-xl mt-6 max-w-3xl mx-auto leading-relaxed">
                        Tous deux formés par l'Institut Franco Européen de Chiropraxie (IFEC), nous continuons de nous former pour avoir un très large panel de techniques supplémentaires à notre formation afin de nous adapter au maximum à nos patients, et ainsi avoir le maximum de résultat.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

                    {/* Alexis */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                        <div className="p-6 sm:p-8">
                            <div className="flex flex-col items-center mb-6">
                                <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full overflow-hidden shadow-lg mb-4">
                                    <img alt="Portrait d'Alexis Moulin, chiropracteur" className="w-full h-full object-cover" src={imgAlexis} loading="lazy" />
                                </div>
                                <h2 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-xl sm:text-2xl">Alexis Moulin</h2>
                                <p className="text-gray-500">Chiropracteur</p>
                            </div>

                            <div className="space-y-4 text-gray-600 text-sm sm:text-base leading-relaxed">
                                <p>
                                    Le sport a toujours été un pilier dans ma vie, avec le karaté en particulier, que j'ai pratiqué pendant 15 ans. Au départ, c'était simplement une manière de me dépenser, mais avec le temps, j'ai ressenti le besoin de mieux comprendre ce que je faisais, pourquoi mon corps réagissait d'une certaine manière, et comment je pouvais l'améliorer. C'est cette quête de compréhension qui m'a conduit vers la chiropraxie, et ça a été un véritable tournant.
                                </p>

                                <p>
                                    Ce métier m'a permis d'explorer en profondeur l'anatomie, de comprendre les mécanismes internes du corps et comment ils peuvent être optimisés pour soulager des douleurs, mais aussi pour améliorer les performances physiques.
                                </p>

                                <p>
                                    Ce que j'apprécie particulièrement dans la chiropraxie, c'est la diversité des outils qu'elle offre pour traiter les patients. Grâce à une formation qui va bien au-delà des simples manipulations, j'ai acquis une compréhension fine de la mécanique du corps humain et de son fonctionnement neurologique. Ces connaissances me permettent d'aborder chaque patient avec une approche personnalisée, en adaptant mes techniques pour répondre précisément à leurs besoins.
                                </p>

                                <div className="bg-gray-50 rounded-xl p-4 mt-4">
                                    <p className="text-gray-700 italic">
                                        Mon objectif n'est pas simplement de traiter les symptômes, mais d'aider mes patients à prendre conscience de leur propre corps, à comprendre ses limites et ses capacités, afin qu'ils atteignent 100% de leur potentiel.
                                    </p>
                                </div>
                            </div>

                            <div className="flex justify-center mt-6">
                                <button style={{ background: Helper.contentLetterColor }} className="text-gray-900 font-semibold px-6 py-3 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSiteAlexis}>
                                    Prendre rendez-vous avec moi
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Emilie */}
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                        <div className="p-6 sm:p-8">
                            <div className="flex flex-col items-center mb-6">
                                <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full overflow-hidden shadow-lg mb-4">
                                    <img alt="Portrait d'Emilie Gouache, chiropracteur" className="w-full h-full object-cover" src={imgEmilie} loading="lazy" />
                                </div>
                                <h2 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-xl sm:text-2xl">Emilie Gouache</h2>
                                <p className="text-gray-500">Chiropracteur</p>
                            </div>

                            <div className="space-y-4 text-gray-600 text-sm sm:text-base leading-relaxed">
                                <p>
                                    La chiropraxie est entrée dans ma vie assez tardivement, vers mes 18 ans, lorsque j'ai eu des douleurs assez importantes aux cervicales. Je suis allée voir un chiropracteur à Paris, qui m'a tout de suite soulagée… ça a été instantané ! J'ai eu l'impression que le chiropracteur lisait et comprenait parfaitement mon corps. Aujourd'hui, c'est cette approche que je souhaite offrir à mes patients : lire à travers leurs corps afin de comprendre la véritable origine des douleurs, et que les améliorations soient présentes le plus rapidement possible.
                                </p>

                                <p>
                                    Je souhaite accueillir en consultation tout profils de patients au cabinet, afin de leurs offrir les soins les plus personnalisés et d'avoir de nettes améliorations sur le long terme. Ancienne danseuse contemporaine de haut niveau durant ma scolarité, je me consacre aujourd'hui pleinement à l'équitation.
                                </p>

                                <div className="bg-gray-50 rounded-xl p-4 mt-4">
                                    <p className="text-gray-700 font-medium mb-2">Spécialisation : Cavaliers de compétition</p>
                                    <p className="text-gray-600 text-sm">
                                        Le corps du cavalier est son outil quotidien, c'est pourquoi il est important qu'il soit fonctionnel afin de pouvoir répondre aux exigences de cette pratique. Il est façonné par la posture spécifique à cheval et, de ce fait, présente des douleurs et des particularités biomécaniques. En raison des exigences anatomiques spécifiques de la discipline, les cavaliers nécessitent une approche adaptée à leur condition physique.
                                    </p>
                                </div>
                            </div>

                            <div className="flex justify-center mt-6">
                                <button style={{ background: Helper.contentLetterColor }} className="text-gray-900 font-semibold px-6 py-3 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSiteEmilie}>
                                    Prendre rendez-vous avec moi
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
